import { controlSizeFallback, cssControlSize } from "../../styles/index.js";
import { Button } from "../Dropdown/Button.js";
import styled, { css } from "../../styled-components.js";
export var Select = styled(Button).withConfig({
  displayName: "Select",
  componentId: "sc-3qvhho-0"
})(["", ""], function (_ref) {
  var $size = _ref.$size;
  return css(["appearance:none;margin-block:0;text-indent:0.01px;text-overflow:'';&::-ms-expand{display:none;}block-size:", ";min-block-size:unset;"], $size === 'small' ? cssControlSize('smaller', controlSizeFallback.small) : cssControlSize('base', controlSizeFallback.medium));
});